import { render, staticRenderFns } from "./MissionGourmande.vue?vue&type=template&id=f4d7273a&scoped=true&"
import script from "./MissionGourmande.vue?vue&type=script&lang=js&"
export * from "./MissionGourmande.vue?vue&type=script&lang=js&"
import style0 from "./MissionGourmande.vue?vue&type=style&index=0&id=f4d7273a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d7273a",
  null
  
)

export default component.exports